var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.49993 0.5C1.34387 0.499892 1.19092 0.543606 1.05849 0.626165C0.92606 0.708723 0.819474 0.826809 0.750867 0.966976C0.68226 1.10714 0.65439 1.26376 0.67043 1.41899C0.68647 1.57422 0.745776 1.72182 0.841595 1.845L6.49993 9.12V12.1667C6.49993 12.296 6.53005 12.4236 6.58791 12.5393C6.64576 12.6551 6.72976 12.7557 6.83326 12.8333L10.1666 15.3333C10.2904 15.4262 10.4376 15.4827 10.5918 15.4966C10.7459 15.5105 10.9009 15.4812 11.0393 15.412C11.1777 15.3428 11.2941 15.2364 11.3755 15.1048C11.4568 14.9731 11.4999 14.8214 11.4999 14.6667V9.11917L17.1583 1.84417C17.2538 1.72098 17.3129 1.57346 17.3288 1.41836C17.3448 1.26326 17.3168 1.10681 17.2483 0.966793C17.1797 0.826773 17.0732 0.708799 16.9409 0.626282C16.8086 0.543765 16.6558 0.500013 16.4999 0.5H1.49993Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterColor);
export default __webpack_public_path__ + "static/media/filterColor.62e4a341c6f673232cc82bf9a247aea4.svg";
export { ForwardRef as ReactComponent };